import classNames from 'classnames'
import Divider from 'Components/divider'
import { GlobalStoreContext } from 'Components/store'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { LoginStoreContext } from 'New/login/login-store'
import Link from 'next/link'
import { useRouter } from 'next/router'
import * as React from 'react'
import styles from './index.module.scss'
interface IInfoModeSwitcherProps {
  style?: React.CSSProperties
  tabName?: string
  className?: string
}
export enum EInfoMode {
  DYNAMIC = 'dynamic',
  STATIC = 'static',
}
interface IMode {
  type: EInfoMode
  text: string
  href: string
  rel?: string
  tips: JSX.Element
}
export const INFO_MODE_KEY = 'info_mode_key'
export default function InfoModeSwitcher({
  style,
  tabName,
  className,
}: IInfoModeSwitcherProps) {
  const isLogin = !!React.useContext(GlobalStoreContext).state.userData?.user_id
  const { openLogin } = React.useContext(LoginStoreContext)
  const router = useRouter()
  const isDynamicFeed = router.asPath.indexOf('/feed') > -1
  const currentMode = isDynamicFeed ? EInfoMode.DYNAMIC : EInfoMode.STATIC
  const modeList: IMode[] = [
    {
      type: EInfoMode.STATIC,
      text: '自主阅读',
      href: '/news/dynamic_motor_car',
      tips: (
        <p
          className={styles['tips-content']}
          onClick={(event) => {
            event.stopPropagation()
            event.preventDefault()
          }}
        >
          自主阅读模式：支持自主选择浏览 最新/最热
          车闻、行情、评测、导购等汽车内容
        </p>
      ),
    },
    {
      type: EInfoMode.DYNAMIC,
      text: '兴趣阅读',
      href: '/feed',
      rel: 'nofollow',
      tips: (
        <p
          className={styles['tips-content']}
          onClick={(event) => {
            event.stopPropagation()
            event.preventDefault()
          }}
        >
          兴趣阅读模式：算法自动为你推荐喜欢的汽车内容。
          {!isLogin && (
            <div>
              Tips:
              <span
                className={styles['tips-login']}
                onClick={(event) => {
                  event.stopPropagation()
                  event.preventDefault()
                  openLogin()
                }}
              >
                登录
              </span>
              后阅读，懂车帝能更精准分析您的兴趣爱好
            </div>
          )}
        </p>
      ),
    },
  ]
  if (isDynamicFeed) {
    modeList.reverse()
  }
  const handleClick = (event: React.MouseEvent, mode: IMode) => {
    if (mode.type === currentMode) {
      event.preventDefault()
      return
    }
    window.localStorage.setItem(INFO_MODE_KEY, mode.type)
    sendTeaCommEvent('clk_event', {
      event_id:
        mode.type === EInfoMode.DYNAMIC
          ? 'interest_reading'
          : 'independent_reading',
      sub_tab: tabName,
      button_name: mode.text,
    })
  }
  return (
    <div className={`${styles.root} ${className}`} style={style}>
      <span className={styles.current}>当前模式</span>
      {modeList.map((mode, index) => (
        <>
          <Link href={mode.href} key={mode.type}>
            <a
              rel={mode.rel}
              className={classNames(styles['model-item'], {
                [styles['is-active']]: mode.type === currentMode,
              })}
              onClick={(event) => handleClick(event, mode)}
            >
              {mode.text}
              {mode.tips}
            </a>
          </Link>
          {index === 0 && (
            <Divider
              width={1}
              height={12}
              color="#E6E8F2"
              style={{ margin: '0 12px' }}
            />
          )}
        </>
      ))}
    </div>
  )
}
